import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import Select from 'react-select';
import UserService from "../services/user.service";

import AuthService from "../services/auth.service";
import userService from "../services/user.service";

const required = value => {
  
  if (!value) {
    
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const email = value => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        This is not a valid email.
      </div>
    );
  }
};

const vusername = value => {
  if (value.length < 3 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        The username must be between 3 and 40 characters.
      </div>
    );
  }
};

const vpassword = value => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        The password must be between 6 and 40 characters.
      </div>
    );
  }
};
 
const depOptions = [
  {label: 'Senior Management', value: 'Senior Management'},
  {label: 'IT Support', value: 'IT Support'},
  {label: 'Recruitment', value: 'Recruitment'},
  {label: 'Tambor Fleet', value: 'Tambor Fleet'},
  {label: 'Tracfast', value: 'Tracfast'},
  {label: 'Regional Manager', value: 'Regional Manager'},
  {label: 'DME4', value: 'DME4'},
  {label: 'DRH1', value: 'DRH1'},
  {label: 'DXE1', value: 'DXE1'},
  {label: 'DRM4', value: 'DRM4'},
  {label: 'DSS2', value: 'DSS2'}
]
export default class Register extends Component {
  constructor(props) {
    super(props);
    this.handleRegister = this.handleRegister.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.onChangePasswordConfirm = this.onChangePasswordConfirm.bind(this);
    this.onChangeDepartment = this.onChangeDepartment.bind(this);

    this.state = {
      username: new URLSearchParams(window.location.search).get('name'),
      email: new URLSearchParams(window.location.search).get('email'),
      password: "",
      passwordConfirm: "",
      successful: false,
      message: "",
      department: ""
    };
  }
  
  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }
  onChangeDepartment(e) {
    this.setState({
      department: e.value
    });
  }
  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }
  onChangePasswordConfirm(e) {
    this.setState({
      passwordConfirm: e.target.value
    });
  }
  handleRegister(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.register(
        this.state.username,
        this.state.email,
        this.state.password
      ).then(
        response => {
          const data = {name: this.state.username, email_skso: this.state.email}
          UserService.markCreated(data).then(
            ress =>{
              this.setState({
                message: response.data.message,
                successful: true
              });
            }
          ).catch(err => console.log(err.message))
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage
          });
        }
      );
    }
  }

  render() {
    const vpasswordConfirm = value => {
      if (value !== this.state.password) {
        return (
          <div className="alert alert-danger" role="alert">
            The password must match.
          </div>
        );
      }
    };
    return (
      <div className="col-md-12">
        <div className="card card-container">
          <img
            src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
            alt="profile-img"
            className="profile-img-card"
          />

          <Form
            onSubmit={this.handleRegister}
            ref={c => {
              this.form = c;
            }}
          >
            {!this.state.successful && (
              <div>
                {/*<div className="form-group">
                  <label htmlFor="email">Department</label>
                  <Select
                    options={depOptions}
                    //className="form-control"
                    //name="department"
                    //value={this.state.department}
                    onChange={e => this.onChangeDepartment(e)}
                    //validations={[required, email]}
                  />
            </div>*/}
                <div className="form-group">
                  <label htmlFor="username">Username</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="username"
                    value={this.state.username}
                    onChange={this.onChangeUsername}
                    validations={[required, vusername]}
                    disabled
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="email"
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                    validations={[required, email]}
                    disabled
                  />
                  
                </div>

                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <Input
                    type="password"
                    className="form-control"
                    name="password"
                    value={this.state.password}
                    onChange={this.onChangePassword}
                    validations={[required, vpassword]}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="password">Confirm Password</label>
                  <Input
                    type="password"
                    className="form-control"
                    name="password"
                    value={this.state.passwordConfirm}
                    onChange={this.onChangePasswordConfirm}
                    validations={[required, vpasswordConfirm]}
                  />
                </div>

                <div className="form-group">
                  <button className="btn btn-primary btn-block">Sign Up</button>
                </div>
                
              </div>
            )}

            {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alert alert-success"
                      : "alert alert-danger"
                  }
                  role="alert"
                >
                  {this.state.message}
                </div>
              </div>
            )}
            <p>* you will use this email and password to use our portal</p>
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
        </div>
      </div>
    );
  }
}
